import { createApp } from 'vue'
import App from './App.vue'
import './tailwind.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './MesRoutes/routes'
import i18n from './locales/i18n'
import store from "./store/store"
import emitter from './emitter/useEmiter'
import Echo from "laravel-echo"
import moment from 'moment'
import Vue3Marquee from 'vue3-marquee'
import pusherJs from 'pusher-js'
import geolocalisation from './js/geolocalisation'
import crypto from './js/Crypt'
import decrypto from './js/Decrypt'

// moment
import 'moment/locale/fr'
import 'moment/locale/en-gb'

// Détecter la langue
const langue = localStorage.getItem('langue') || 'fr'

console.log("Langue détectée :", langue)

// Appliquer la locale globale à moment.js
moment.locale(langue)

//Pusher.logToConsole = true;
window.moment = moment
window.emitter = emitter
window.Pusher = pusherJs

// Créer une seule instance de l'application
const app = createApp(App)

// Définir les propriétés globales
app.config.globalProperties.$moment = moment
app.config.globalProperties.$mitt = emitter
app.config.globalProperties.$crypto = crypto
app.config.globalProperties.$decrypto = decrypto
app.config.globalProperties.$geo = geolocalisation

// Configurer Laravel Echo
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: "219a1f8debafbc8a8e08",
    wsHost: store.state.host,
    wsPort: store.state.port,
    cluster: "mt1",
    forceTLS: false,
    disableStats: true,
    authEndpoint: store.state.api + 'broadcasting/auth',
    auth: {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        }
    },
    logToConsole: true,
})

// Ajouter les plugins et monter l'application
app.use(Vue3Marquee)
   .use(i18n)
   .use(emitter)
   .use(moment)
   .use(router)
   .use(store)
   .use(VueAxios, axios)
   .mount('#app')
